import { axiosInstance } from "@/utils/axios";
import type { AuthToken, Me, SignInBody } from "@/types/auth";

export const signinRequest = async (body: SignInBody): Promise<AuthToken> => {
  const { data } = await axiosInstance.post("/auth/sign-in", body);
  return data;
};

export const getMeRequest = async (): Promise<Me> => {
  const { data } = await axiosInstance.get("/users/me");
  return data;
};
